import Vue from 'vue'

export default {
  list: async () => {
    return Vue.axios.get('/periods');
  },
  save: async (period) => {
    let formData = new FormData()
    for (const field in period) if (period.hasOwnProperty(field)) {
      formData.append('period[' + field + ']', period[field])
    }
    return Vue.axios.post('/periods', formData);
  }
}
